import React from 'react';

const TemplateCard = ({ template, onPreview, onSelect }) => {
    return (
        <div className="col-lg-4 col-md-6 mb-4">
            <div className="card h-100 border-0 shadow-sm template-card">
                <div className="template-card-img-container">
                    <img
                        src={template.thumbnailUrl}
                        className="card-img-top"
                        alt={template.name}
                    />
                </div>
                <div className="card-body template-card-body">
                    <h5 className="card-title text-center template-card-title">{template.name}</h5>
                    <div className="template-card-actions">
                        <button
                            className="btn btn-outline-secondary btn-preview"
                            onClick={() => onPreview(template)}
                        >
                            Preview
                        </button>
                        <button
                            className="btn btn-primary btn-select"
                            onClick={() => onSelect(template.templateId)}
                        >
                            Select Template
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TemplateCard;